export default __webpack_public_path__ + "static/media/25l_drybag.d7f18d43.jpg";